/**
 * Generated runtime TestId mirror for frontend/src/pages/RestrictionRuleRequestEdit.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const RestrictionRuleRequestEditTestIds = {
  btnBackNotEditable: "btn-back-not-editable",
  restrictionRuleRequestEditPage: "restriction-rule-request-edit-page"
} as const;
